import React from 'react';
import PageHeader from '../components/ui/PageHeader';
import SafeIcon from '../common/SafeIcon';
import CTASection from '../components/home/CTASection';
import { siteData } from '../data/content';

export default function ServiceAreas() {
  return (
    <div className="bg-slate-950">
      <PageHeader 
        title="Service Areas" 
        subtitle="Bringing elite auto detailing to Jacksonville and surrounding communities."
      />

      <div className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="text-center max-w-3xl mx-auto mb-16">
            <SafeIcon name="Map" className="text-5xl text-blue-500 mx-auto mb-6" />
            <h2 className="text-3xl md:text-4xl font-black text-white uppercase tracking-tight mb-6">Local Auto Detailing Near You</h2>
            <p className="text-slate-400 text-lg">
              Based in Jacksonville, FL, A.R. Elite Detailing provides premium mobile and shop-based services across the region. We are equipped to bring the showroom finish directly to your driveway or workplace.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
            {siteData.business.areas.map((area, index) => (
              <div key={index} className="bg-slate-900 border border-slate-800 p-6 flex items-start gap-4 hover:border-blue-500 transition-colors">
                <SafeIcon name="MapPin" className="text-blue-500 text-2xl flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-xl font-bold text-white mb-2">{area}, FL</h3>
                  <p className="text-slate-400 text-sm">Providing full interior, exterior, and ceramic coating services in {area}.</p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-slate-900/50 border border-slate-800 p-8 text-center max-w-4xl mx-auto">
            <h3 className="text-xl font-bold text-white mb-2">Don't see your city?</h3>
            <p className="text-slate-400 mb-6">We often accommodate clients slightly outside our standard radius for premium packages or multi-vehicle bookings.</p>
            <a href={`tel:${siteData.business.phone.replace(/\D/g,'')}`} className="text-blue-500 font-bold hover:text-white transition-colors">
              Call {siteData.business.phone} to check availability
            </a>
          </div>

        </div>
      </div>
      <CTASection />
    </div>
  );
}